export default __webpack_public_path__ + "static/headerImage-86b61b21aa29e2b757c38d3b7ed139ae35151d1be3dc53863b506afbb0b44414.png";